import React from "react";
import { ConfirmedFixedPriceSection } from "./ConfirmedFixedPriceSection";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingDataOwnership, BookingStatus } from "../../../Services/BookingEntities";

/**
 * Decides whether to display the confirmed Fixed Price and payment details section based on the booking conversion and payment status.
 */
export const MaybeConfirmedFixedPriceSection: React.FC = () => {

    const isPaymentConfirmed = useAppState(state => state.PhoneToCnp.IsPaymentConfirmed);
    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    if (!isPaymentConfirmed && !bookingDetails.Payment) return null;
    if (bookingDetails.TrackingInfo.BookingStatusID > BookingStatus.Completed) return null;

    // User's with read-only access (shared booking) can't view this section.
    if (bookingDetails.DataOwnership === BookingDataOwnership.ReadOnlyLink) return null;

    return (
        <ConfirmedFixedPriceSection />
    )
}